import type { AppDispatch, RootState } from '../../../store';
import { IFirm, setCurrentFirm } from './firmSlicer';
import { setCurrentFirmList } from './firmListSlicer';
import { setCurrentCompanyList } from './companySlicer';

export const syncFirms = (firms: IFirm[]) => (dispatch: AppDispatch, getState: () => RootState) => {
  const currentId = getState().currentFirm.currentFirm?._id;
  const current = firms.find(firm => firm._id === currentId) ?? firms[0] ?? null;
  dispatch(setCurrentFirmList(firms));
  dispatch(setCurrentFirm(current));
  dispatch(setCurrentCompanyList(current?.companies ?? []));
};
